import script from "./MaterialOrderPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialOrderPrint.vue?vue&type=script&setup=true&lang=js"

import "./MaterialOrderPrint.vue?vue&type=style&index=0&id=0a6b595c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6b595c"]])

export default __exports__